

$(".product__btn").on("click", function (e) {
  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
});

function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      $("body").addClass("cart-drawer-open");
      sectionRedering();
    },
    error: function (err) {
      console.log(err);
    },
  });
};

function sectionRedering() {
  fetch("?section_id=cart")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__wrapper", cart__html);
      $(".cart-drawer__wrapper").replaceWith(render__html);
      if ($(Window).width() < 768) {
          $('.cart-drawer__collection .product-cards').slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
          });
      }
    });

  // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart em", cart__html);
      $(".header__cart em").replaceWith(render__html);
    });

    // var $slider = $('#your-slider');
    
      

}





function openDropdown(el) {
  const dropdown = el.parentElement;
  const menu = el.nextElementSibling;

  document.querySelectorAll(".dropdown-menu").forEach(m => {
    if (m !== menu) {
      m.style.display = "none";
    }
  });

  if (menu.style.display === "block") {
    menu.style.display = "none";
  } else {
    menu.style.display = "block";
  }
}

document.addEventListener("click", (e) => {
  if (!e.target.closest(".dropdown")) {
    document.querySelectorAll(".dropdown-menu").forEach(m => {
      m.style.display = "none";
    });
  }
});




$(document).on("click", ".dropdown-menu div", function () {
  var quantity = $(this).data("value");
  var dropdown = $(this).closest(".dropdown");
  var data_line = dropdown.data("line");

  dropdown.find(".dropdown-value").text(quantity);

  changeQuantity(dropdown, quantity, data_line);
});

function changeQuantity(dropdown, quantity, line) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      line: line,
      quantity: quantity
    },
    success: function (data) {
      console.log("Cart updated", data);
      sectionRedering();
    },
    error: function () {
      console.log("Error from quantity update");
    }
  });
}

$(document).on("click", ".cart-drawer__product-dlt", function (event) {
  event.preventDefault();
  var data_line = $(this).data("line");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      line: data_line,
      quantity: 0
    },
    success: function (data) {
      sectionRedering(); 
    },
    error: function () {
      console.log("Error removing item");
    }
  });
});



// // increment quantity in cart drawer
// function increment(el) {
//   var input = el.previousElementSibling;
//   var value = parseInt(input.value);
//   console.log(value)
//   value = isNaN(value) ? 0 : value
//   value++;
//   input.value = value;
//   changeQuantity(input);

// }
// // decrement quantity in cart drawer
// function decrement(el) {
//   var input = el.nextElementSibling;
//   var value = parseInt(input.value);
//   if (value > 0) {
//     value = isNaN(value) ? 0 : value;
//     value--;
//     input.value = value;
//     changeQuantity(input);
//   }
// }

// function changeQuantity(input) {

//   var quantity = $(input).val();
//   var data_line = $(input).attr("data-line");
//   var data = {
//     "line": data_line,
//     "quantity": quantity
//   };
//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: data,
//     success: function (data) {
//       console.log(data);
//       sectionRedering();
//     },
//     error: function (err) {
//       console.log("Error from quantity update")
//     }
//   })


// }


// function removeItem(event, el) {
//   event.preventDefault();
//   var data_line = $(el).attr("data-line");
//   console.log(data_line)
//   var deleteData = {
//     "line": data_line,
//     "quantity": 0
//   };

//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: deleteData,
//     success: function (data) {

//       sectionRedering();
//     }
//   })
// }




// function updateVariantImage(variant_featured_img) {
//   if (variant_featured_img) {
//     $(".main-product__big-item").each(function () {
//       let img__src = $(this).find("img").attr("src");
//       if (variant_featured_img === img__src) {
//         let index = $(this).closest(".main-product__big-item").attr("data-slick-index");
//         $('.main-product__big-items').slick('slickGoTo', index);
//       }

//     })
//   }
// }


function selectedVarint() {
  var slectedId = $(".select__variant").val();
  var url = new URL(window.location.href);
  url.searchParams.set("variant", slectedId);
  window.history.replaceState({}, "", url);
}


//   // match variant
var option_stat = $('.product__color span');
function matchVariant() {
  var updateValue = "";
  $(".product__type-item input[type='radio']:checked").each(function () {

    updateValue += (updateValue ? " / " : "") + $(this).val();
    option_stat = $(this).parent().parent().prev().find('.product__color span');
  })

  var isMatchFound = false;
  $(".select__variant option").each(function () {

    var optionValue = $(this).text().trim();

    if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true);


      var variant__available = $(this).attr("data-variant-available");
      var variant__price = $(this).attr("data-variant-price");

      // var variant_featured_img = $(this).attr("data-variant-featured-img");
      $(option_stat).text(optionValue);
      //$(".product__price-right").text(variant__price);
      $(".product__price-right").html('<span class="money">'+variant__price+'</span>');
      // call update variant image function 
      // updateVariantImage(variant_featured_img);
      if (variant__available == 'false') {
        $(".product__btn").addClass("disabled");
      } else {
        $(".product__btn").removeClass("disabled");

      }
    }
    return true;

  });
}

$(".product__type-item input[type='radio']").change(function () {
  matchVariant();
  selectedVarint();
})
$(document).ready(function () {
  matchVariant();
});



// function increment_p(el) {
//   var input = el.previousElementSibling;
//   var value = parseInt(input.value);
//   value = isNaN(value) ? 0 : value
//   value++;
//   input.value = value;
// }

// function decrement_p(el) {
//   var input = el.nextElementSibling;
//   var value = parseInt(input.value);
//   if (value > 1) {
//     value = isNaN(value) ? 1 : value;
//     value--;
//     input.value = value;


//   }
// }


